import * as Sentry from "@sentry/react";
import axios from "axios";
import { noop } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import { BACKEND_URL } from "@/lib/constants/constants";
import { useTenant } from "@/providers/session";

type Props = {
  tokenId: string;
  onSuccess?: () => Promise<void> | void;
};

export const SignOutButton = ({ tokenId, onSuccess = noop }: Props) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { tenantId } = useTenant();

  const handleDisconnect = async () => {
    setLoading(true);
    const toastId = toast.loading(t("generic_loading"));
    try {
      await axios.delete(`${BACKEND_URL}/api/auth/datev/logout`, {
        params: { tokenId, tenantId },
      });
      toast.dismiss(toastId);
      await onSuccess();
    } catch (e) {
      Sentry.captureException(e);
      toast.error(t("generic_error"), { id: toastId, richColors: true });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button variant="outline" onClick={handleDisconnect} disabled={loading}>
      {t("integrations.datev.disconnect")}
    </Button>
  );
};
